const translationRO = {
    generalData: 'Date generale',
    name: 'Nume complet',
    nameParam: 'Nume',
    date: 'Data',
    phoneNumber: 'Număr de telefon',
    patientGeneralData: 'Date generale ale pacientului',
    detailData: 'Date detaliate',
    feetMeasurement: 'Măsurători ale piciorului',
    overview: 'Prezentare generală',
    firstNameRequired: 'Prenumele este obligatoriu',
    firstName: 'Prenume',
    lastName: 'Nume de familie',
    identityId: 'ID identitate',
    emailLabel: 'E-mail',
    phoneNumber1: 'Număr de telefon 1',
    phoneNumber2: 'Număr de telefon 2',
    gender: 'Gen',
    selectGender: 'Vă rugăm să selectați un gen',
    male: 'Masculin',
    female: 'Feminin',
    dateofBirth: 'Data nașterii',
    birthDateRequired: 'Data nașterii este obligatorie',
    height: 'Înălțime',
    weight: 'Greutate',
    shoeSize: 'Mărime pantofi',
    euShoeSize: 'Mărime pantofi (EU)',
    rightHanded: 'Dreptaci',
    leftHanded: 'Stângaci',
    controlExamSchedule: 'Programare examen de control',
    ekovelReport: 'Raport Ekovel',
    generalExamination: 'Examinare generală',
    optimalWeight: 'Greutate optimă',
    feetParametes: 'Parametrii piciorului',
    role: 'Rol',
    displayName: 'Nume afișat',
    userName: 'Nume de utilizator',
    organization: 'Organizație',
    active: 'Activ',
    deleteConfirmation: 'Confirmare ștergere',
    areYouSureToDelete: 'Sigur doriți să ștergeți utilizatorul',
    delete: 'Șterge',
    cancel: 'Anulează',
    deactivate: 'Dezactivează',
    activate: 'Activează',
    activateUser: 'Activează utilizatorul',
    deactivateConfirmation: 'Confirmare dezactivare',
    areYouSureDeactivate: 'Sigur doriți să dezactivați utilizatorul',
    areYouSureActivate: 'Sigur doriți să activați utilizatorul',
    updateSerialNumber: 'Actualizare număr de serie',
    areYouSureToDeleteUser: 'Sigur doriți să ștergeți utilizatorul',
    actions: 'Acțiuni',
    parameter: 'Parametru',
    value: 'Valoare',
    ekovelStepCorrectsize: 'Pasul corect al Ekovel',
    initialHeight: 'Înălțime inițială',
    optimalHeight: 'Înălțime optimă',
    firstCheck: 'Prima verificare',
    secondCheck: 'A doua verificare',
    thirdCheck: 'A treia verificare',
    therapy: 'Terapie',
    leftFoot: 'Picior stâng',
    rightFoot: 'Picior drept',
    serialNumber: 'Număr de serie',
    footLength: 'Lungimea piciorului (mm)',
    footWidth: 'Lățimea piciorului (mm)',
    left: 'Stânga',
    right: 'Dreapta',
    back: 'Înapoi',
    finish: 'Finalizare',
    next: 'Următorul',
    selectLeg: 'Selectați piciorul',
    legLengthDifference: 'Diferența de lungime a piciorului',
    adjustmentInterval: 'Interval de ajustare',
    adjustmentPeriod: 'Perioadă de ajustare AI',
    week: 'Săptămână',
    weeks: 'săptămâni',
    serialNumberDate: 'Data numărului de serie',
    checkExaminationSchedule: 'Verificați programarea examinării',
    escSize: 'Mărime ESC',
    saveAndOpenReport: 'Salvați și deschideți raportul',
    create: 'Creează',
    noRowsToShowPatients: 'Nu există date disponibile',
    DepthOfFootArch: 'Adâncimea arcului piciorului',
    DegreeOfTendon: 'Poziția tendonului',
    LegLengthDifference: 'Diferența de lungime a piciorului',
    FootprintSplit: 'Împărțirea amprentei piciorului',
    FootParamDescription: 'Descrierea parametrilor piciorului',
    report: 'Raport',
    examinationDate: 'Data examinării',
    leftFootMeasurement: 'Măsurători picior stâng',
    rightFootMeasurement: 'Măsurători picior drept',
    footParametersLeft: 'Parametrii piciorului stâng',
    footParametersRight: 'Parametrii piciorului drept',
    optimalMlaDepth: 'Adâncimea optimă a MLA',
    optimalMlaHeight: 'Înălțimea optimă a MLA',
    mlaDescendingLevel: 'Nivelul de coborâre MLA',
    mlaDescending: 'Coborâre MLA',
    tendonPosition: 'Poziția tendonului',
    legAlignement: 'Alinierea piciorului',
    and: 'Și',
    selectedLeg: 'Piciorul selectat',
    allAdmins: 'TOȚI ADMINISTRATORII',
    allUsers: 'TOȚI UTILIZATORII',
    allPatients: 'TOȚI PACIENȚII',
    therapyDuration: 'Durata terapiei',
    medialArchDisplacement: 'Deplasare arc medial',
    verticalDisplacement: 'Deplasare verticală',
    horizontalDisplacement: 'Deplasare orizontală',
    displacementPoourcentage: 'Procentaj de deplasare',
    displacementLevel: 'Nivelul de deplasare',
    medialArchDepth: 'Adâncimea arcului medial X [mm]',
    medialArchHeight: 'Înălțimea arcului medial Y [mm]',
    tendonBendingDegree: 'Gradul de îndoire al tendonului',
    medialArchOptimalDepth: 'Adâncimea optimă a arcului medial Xo [mm]',
    medialArchOptimalHeight: 'Înălțimea optimă a arcului medial Yo [mm]',
    backToPatientsList: 'Înapoi la formular',
    allStepsAreDone: 'Toți pașii sunt finalizați',
    user: 'Utilizator',
    yes: 'Da',
    no: 'Nu',
    selectAlignment: 'Selectați alinierea',
    createAdmin: 'Creează administrator/utilizator',
    createUser: 'Creează utilizator',
    createPatient: 'Creează pacient',
    editPatient: 'Editează pacient',
    serialNumberSucces: 'Numărul de serie a fost actualizat cu succes',
    noRowsToShow: 'Nu există rezultate de afișat',
    admittedBy: 'Admis de',
    logout: 'Deconectare',
    search: 'Căutare',
    suborganization: 'Suborganizație',
    town: 'Oraș',
    userSuccess: "Creat cu succes",
    emailAlreadyExist: "Eroare: Emailul există deja",
    loginErroMEssage: 'Numele de utilizator sau parola sunt incorecte.',
    accept: 'Acceptă',

    privacyPolicy: "Politica de confidențialitate",
    lastUpdated: "Data ultimei actualizări: 03.04.2025",
    privacyPolicyIntro: "Bine ați venit în aplicația companiei Ekovel. Ne angajăm să protejăm confidențialitatea și siguranța datelor dumneavoastră personale. Această Politică de confidențialitate explică ce date colectăm, cum le folosim și cum le păstrăm.",
    dataCollectionTitle: "1. COLECTAREA DATELOR",
    personalData: "Date personale ale pacienților: nume, prenume, data nașterii, informații de contact.",
    therapyData: "Date despre terapie: diagnostic medical, tratamente recomandate, date despre branțurile ortopedice.",
    technicalData: "Date tehnice: informații despre dispozitiv, adresă IP, date despre utilizarea aplicației.",
    dataUsageTitle: "2. UTILIZAREA DATELOR",
    dataUsage1: "Gestionarea evidenței pacienților și terapiilor acestora.",
    dataUsage2: "Crearea și personalizarea branțurilor ortopedice.",
    dataUsage3: "Îmbunătățirea calității serviciilor și funcționalității aplicației.",
    dataUsage4: "Îndeplinirea obligațiilor legale și reglementare.",
    dataStorageTitle: "3. PĂSTRAREA ȘI PROTECȚIA DATELOR",
    dataProtection: "Datele dumneavoastră sunt stocate pe servere sigure, cu acces restricționat și sunt protejate prin măsuri de securitate corespunzătoare. Accesul la date este permis doar persoanelor autorizate, iar datele nu sunt partajate cu terțe părți fără consimțământul dumneavoastră, cu excepția cazului în care acest lucru este impus de lege.",
    userRightsTitle: "4. DREPTURILE UTILIZATORILOR",
    userRights1: "Accesați datele dumneavoastră.",
    userRights2: "Solicitați corectarea datelor incorecte.",
    userRights3: "Solicitați ștergerea datelor atunci când nu mai sunt necesare.",
    userRights4: "Retragerea consimțământului pentru prelucrarea datelor.",
    contactRights: "Pentru a vă exercita drepturile, contactați-ne la adresa de email ekovelcentar@gmail.com",
    privacyPolicyAcceptanceTitle: "5. ACCEPTAREA POLITICII DE CONFIDENȚIALITATE",
    privacyPolicyAcceptance: "Prin utilizarea acestei aplicații, utilizatorii confirmă că au citit, înțeles și sunt de acord cu Politica de confidențialitate. La prima utilizare a aplicației, va fi afișată această Politică de confidențialitate, iar utilizarea continuă a aplicației va fi posibilă doar după ce utilizatorul apasă pe butonul „Sunt de acord”.",
    contactTitle: "6. CONTACT",
    contactIntro: "Dacă aveți întrebări cu privire la această Politică de confidențialitate, ne puteți contacta la:",
    companyName: "EKOVEL CENTAR DOO",
    companyAddress: "Ugrinovački put 104, 11080, Belgrad (Zemun), Serbia",
    companyEmail: "Email: ekovelcentar@gmail.com",
    companyPhone: "Telefon: 0113774750",
    policyUpdateNotice: "Ne rezervăm dreptul de a actualiza periodic această Politică de confidențialitate. Veți fi informat în timp util despre orice modificări prin intermediul aplicației."
  
};

export { translationRO };
